import styled from 'react-emotion'
import { mobile, customDevice, tablet } from '../../../../utils/mixins'

export const StarsAboutIbCricketSection = styled('div')``

export const ResponsiveContainer = styled('div')`
  width: 1124px;
  margin: auto;
  display: flex;
  flex-direction: column;
  ${mobile} {
    width: 88.8%;
    margin: auto;
  }
  ${tablet} {
    width: 90%;
    margin: auto;
  }
  ${customDevice(1024, 1140)} {
    width: 90%;
    margin: auto;
  }
`

export const StarsAboutIbCricketContainer = styled(ResponsiveContainer)`
  ${customDevice(1140, 1250)} {
    width: 90%;
    margin: auto;
  }
`

export const PrevArrowSection = styled('div')`
  position: absolute;
  left: -4%;
  top: 34%;
  z-index: 10;
  cursor: pointer;
  ${mobile} {
    left: -11%;
    top: 36%;
  }
  ${tablet} {
    left: -8%;
  }
`
export const SliderContainer = styled('div')`
  padding-top: 20px;
  position: relative;
  ${customDevice(320, 602)} {
    margin-top: 15px;
  }
`

export const TestimonialsSvgContainer = styled('div')`
  pointer-events: none;
  user-select: none;
  display: flex;
  opacity: ${props => (props.disableArrow ? '0.4' : null)};
`
export const NextArrowSection = styled('div')`
  cursor: pointer;
  position: absolute;
  right: -4%;
  top: 34%;
  z-index: 10;
  ${mobile} {
    right: -9%;
    top: 36%;
  }
  ${tablet} {
    right: -8%;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/TestimonialSlick/styledComponents.js